import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { CustomReportComponent } from './custom-report.component';

@NgModule({
  declarations: [CustomReportComponent],
  imports: [
    FuseSharedModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
  ],
  exports: [CustomReportComponent],
})
export class CustomReportModule {}
